module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/215.f5f11b4a.png";